import { Input, InputProps } from 'libs/ui';

import { FieldType } from '../types';
import { useField } from '../useField';

export interface TextFieldProps
  extends FieldType,
    Omit<InputProps, 'name' | 'onChange' | 'onChangeText' | 'value' | 'type'> {
  minNumber?: number;
  maxNumber?: number;
  checkNumber?: (value: string | undefined) => boolean;
  format?: (v?: string) => string | number | undefined;
}

export const NumberField = ({
  name,
  allowSubmit,
  minNumber,
  maxNumber,
  readOnly,
  checkNumber,
  format,
  ...props
}: TextFieldProps) => {
  const { field, helpers, inputProps, meta } = useField<
    string | number | undefined
  >(name, {
    allowSubmit,
  });

  return (
    <Input
      {...props}
      name={name}
      value={field.value ?? ''}
      onBlur={field.onBlur(name)}
      onChange={() => {
        if (meta.isError) {
          helpers.setError(undefined);
        }
      }}
      onChangeText={(v) => {
        if (
          !v ||
          (/^[-\d]\d*$/.test(v) &&
            (maxNumber === undefined || Number(v) <= maxNumber) &&
            (minNumber === undefined || Number(v) >= minNumber) &&
            (!checkNumber || checkNumber(v)))
        ) {
          const value = format ? format?.(v) : v;
          helpers.setValue(value);
        }
      }}
      {...inputProps}
      readOnly={readOnly || inputProps.readOnly}
    />
  );
};
